import { store } from '@/state/store';
import { UTILS__graph_ui } from '@/utils/UTILS__graph_ui';
import { DTO_GRAPH__instance } from '@shared/dto/generation/graph_invoke/_graph/DTO_GRAPH__instance';

export function FN_GRAPH_UPDATE__edge_remove__by_event(graph: DTO_GRAPH__instance) {
  let { g_graph__edge_id_selected } = store.getState().slice_ui;

  let edge = graph.edge__try_get_by_id(g_graph__edge_id_selected);

  if (edge.is_stub()) return false;

  graph.edges__delete([edge]);

  UTILS__graph_ui.edge__deselect();

  return true; //need to update graph remotely
}
